import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { BudgetView, UpsertBudgetRequest } from '@financial/shared';
import { api } from '../../lib/api';
import { currentCurrency } from '../../lib/format';
import { notify } from '../../store/notifications';

export function useBudget(month: string) {
  const currency = currentCurrency();
  return useQuery({
    queryKey: ['budget', month, currency],
    queryFn: async (): Promise<BudgetView> => {
      const res = await api.get<BudgetView>(`/budgets/${month}`, { params: { currency } });
      return res.data;
    },
  });
}

export function useUpsertBudget(month: string) {
  const currency = currentCurrency();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: UpsertBudgetRequest): Promise<BudgetView> => {
      const res = await api.put<BudgetView>(`/budgets/${month}`, body, { params: { currency } });
      return res.data;
    },
    onSuccess: (data) => {
      qc.setQueryData(['budget', month, currency], data);
      notify.success('Presupuesto actualizado');
    },
  });
}
